// import Velocity from "velocity-animate"

let scrolling = false

export const isScrolling = value => {
  if (typeof value === "undefined") {
    return scrolling
  }
  // console.log("set scrolling to", value)
  scrolling = value
}

export function smoothSailing(args = {}) {
  if (typeof window === "undefined") {
    return
  }

  const defaults = {
    destination: 0,
    duration: 300,
    easing: "easeOutQuad",
    callback: () => { },
    offset: 300,
    container: false,
  }

  const options = { ...defaults, ...args }

  const start = options.container
    ? options.container.scrollTop
    : window.pageYOffset

  const startTime =
    "now" in window.performance ? performance.now() : new Date().getTime()

  const documentHeight = options.container
    ? Math.max(
      options.container.clientHeight,
      options.container.scrollHeight,
      options.container.offsetHeight
    )
    : Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    )

  const windowHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.getElementsByTagName("body")[0].clientHeight
  const destinationOffset =
    typeof options.destination === "number"
      ? options.destination
      : options.destination.offsetTop
  let destinationOffsetToScroll = Math.round(
    documentHeight - destinationOffset < windowHeight
      ? documentHeight - windowHeight
      : destinationOffset
  )

  isScrolling(true)

  if ("requestAnimationFrame" in window === false) {
    window.scroll(0, destinationOffsetToScroll)
    if (options.callback) {
      options.callback()
    }
    return
  }

  function scroll() {
    const now =
      "now" in window.performance ? performance.now() : new Date().getTime()
    const time = Math.min(1, (now - startTime) / options.duration)
    const timeFunction = easings[options.easing](time)
    const el = options.container ? options.container : window
    const offset = options.container
      ? options.container.scrollTop
      : window.pageYOffset

    if (typeof el.scroll === 'function') {
      el.scroll(
        0,
        Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start)
      )

      if (offset === destinationOffsetToScroll) {
        isScrolling(false)

        if (options.callback) {
          options.callback()
        }

        return
      }

      requestAnimationFrame(scroll)
    }
  }

  scroll()
}

const easings = {
  linear(t) {
    return t
  },
  easeInQuad(t) {
    return t * t
  },
  easeOutQuad(t) {
    return t * (2 - t)
  },
  easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
  },
  easeInCubic(t) {
    return t * t * t
  },
  easeOutCubic(t) {
    return --t * t * t + 1
  },
  easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
  },
  easeInQuart(t) {
    return t * t * t * t
  },
  easeOutQuart(t) {
    return 1 - --t * t * t * t
  },
  easeInOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t
  },
  easeInQuint(t) {
    return t * t * t * t * t
  },
  easeOutQuint(t) {
    return 1 + --t * t * t * t * t
  },
  easeInOutQuint(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t
  },
}
